import { Component, OnInit, Input, Output, OnChanges, EventEmitter, OnDestroy} from '@angular/core';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { AutoFocusModule } from 'primeng/autofocus';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { AfLimitToPipe } from '@shared/filters/af-limit-to/af-limit-to.pipe';

@Component({
    selector: 'box-comments',
    templateUrl: './box-comments.component.html',
    standalone: true,
    imports: [NgClass, AfTranslateDirective, TooltipModule, AutoFocusModule, FormsModule, AfOrderByPipe, AfTranslatePipe, ConvertDatePipe, AfLimitToPipe]
})
export class BoxCommentsComponent implements OnInit, OnChanges, OnDestroy {
  isLanding: Boolean = this.customLanding.isLanding();
  subscribers: any = {};
  skin: string = this.globalCfg.skin
  userPermissions: any = this.permissions.getPermissions();
  boxComments: any = {
    showCommentBox: false,
    readMoreText: false,
    noComments: true,
    taskStateNoEditable: false,
    commentList: [],
    commentListFilter: [],
    fullScreen: false,
    // hasPermissions: this.userPermissions !== 'none'
  }

  constructor( private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private permissions: UserPermisionsFactory,
    private broadcastService: BroadcastService,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private apiService: ApiServiceService,
    private customLanding: CustomLandingFactory) {}

  @Input() conceptObjectId: any = null;
  @Input() taskId: any = null;
  @Input() taskState: any = null;
  @Input() blockClass: any = null;
  @Input() readOnly: any = false;
  @Output() launchAction = new EventEmitter();

  ngOnInit(): void {
    this.subscribers.addNewCommentBroadcast = this.broadcastService.subscribe('addNewComment', (data:any)=>{
      this.createNewComment(data.commentText);
    })
  }

  ngOnChanges(){
    let that: any = this.boxComments;
    if(this.conceptObjectId){
      that.conceptObjectId = this.conceptObjectId
    }
    if(this.taskId){
      that.taskId = this.taskId
    }
    this.boxComments.url = that.conceptObjectId && that.conceptObjectId !== 'view'?'comments/'+that.conceptObjectId: 'comments/task/'+that.taskId;
    if ((that.taskId || that.conceptObjectId) && that.conceptObjectId !== 'view'){
      this.getComments();
    }
    if(this.taskState){
      that.taskState = this.taskState;
      that.taskStateNoEditable = (that.taskState === 5 || that.taskState === 6);
    }
  }

  getComments(){
    this.apiService.get(this.boxComments.url)
      .then((data:any)=>{
        this.boxComments.commentList = data.reverse();
        this.showComments();
      }, (errorData:any)=>{
        this.boxComments.commentList = [];
      });
  }

  showComments(){
    let that: any = this.boxComments;
    if(that.commentList.length){
      that.commentListFilter = [];
      that.commentList.forEach((comment:any) => {
        comment.showOptions = comment.createdBy === this.context.user.userId;
        if(comment.createdByContact){
          comment.showOptions = comment.createdByContact === this.context.user.contactId;
        }
        comment.commentTextarea = comment.commentText.split('<br>').join('\r\n');
      });
      that.commentListFilter = that.commentList
    }else{
      that.commentListFilter = [];
    }
  }

  newComment(){
    this.boxComments.showCommentBox = true;
  }

  cancelComment(comment:any){
    comment.commentTextarea = comment.commentText.split('<br>').join('\r\n');
    this.boxComments.commentText = '';
    comment.edit = false;
    this.boxComments.edit = false;
    this.boxComments.showCommentBox = false;
  }

  createNewComment(text:any){
    let textToAdd =!text? this.boxComments.commentText.replace(/(?:\r\n|\r|\n)/g, '<br>') : text;
    this.apiService.add(this.boxComments.url, {commenttext: textToAdd})
      .then((data:any)=>{
        data.author = this.context.user.fullName;
        this.boxComments.commentList.splice(0, 0, data);
        this.boxComments.showCommentBox = false;
        this.boxComments.commentText = '';
        this.showComments();
      });
  }

  deleteComment(comment:any){
    this.modalService.infoModal({ text: this.translate.instant('comments.delete-comment'), typeButtons: 'cancelRemove' })
      .subscribe((result:any)=>{
        if(result.result ==='ok'){
          this.loader.openLoader('comment-template-delete-comment')
          this.apiService.delete('comments', comment.commentId)
            .then((data:any)=>{
              this.loader.closeLoader(['comment-template-delete-comment']);
              this.boxComments.commentList = this.commonUtilsService.deleteElement( comment, this.boxComments.commentList , 'commentId');
              this.modalService.successModal({ text: this.translate.instant('comments.delete-comment-ok') });
          }, ()=>{
            this.loader.closeError();
          })
        }else{
          this.loader.closeError();
        }
      })
  }

  editComment(comment: any) {
    if (!comment.showOptions || this.boxComments.taskStateNoEditable || (this.boxComments.conceptObjectId && this.readOnly)) {
      return;
    }

    this.boxComments.commentList.forEach((comment: any) => {
      comment.edit = false;
    });
    this.boxComments.showCommentBox = false;
    comment.edit = !comment.edit;
    if (!this.boxComments.fullScreen) {
      this.boxComments.edit = !this.boxComments.edit;
    }
  }

  closeComment(comment:any = null){
    this.boxComments.showCommentBox = false;
    if(comment !== null){
      comment.edit = false;
    }
  }

  changeComment(comment:any){
    if(comment.commentTextarea.replace(/(?:\r\n|\r|\n)/g, '<br>') !== ''){
      this.modalService.infoModal({ text: this.translate.instant('comments.modify-comment'), typeButtons: 'cancelModify' })
        .subscribe((result:any)=>{
          if(result.result==='ok'){
            this.loader.openLoader('comment-template-edit-comment');
            comment.commentText = comment.commentTextarea.replace(/(?:\r\n|\r|\n)/g, '<br>');
            this.apiService.patch('comments', comment.commentId, comment)
              .then((data:any)=>{
                this.loader.closeLoader('comment-template-edit-comment');
                this.boxComments.edit = false;
                comment.edit = false;
                comment.commentTextarea = comment.commentText.split('<br>').join('\r\n');
                this.boxComments.showCommentBox = false;
                this.boxComments.commentText = '';
                this.showComments();
                this.modalService.successModal({ text: this.translate.instant('comments.modify-comment-ok') });
              }, (errorData:any)=>{
                comment.commentTextarea = comment.commentText.split('<br>').join('\r\n');
                this.boxComments.edit = false;
                comment.edit = false;
                this.loader.closeError();
              })
          }else{
            this.loader.closeError();
          }
        });
    }else{
      let oldcomment = comment.commentText;
      comment.commentTextarea = oldcomment.split('<br>').join('\r\n');
      this.boxComments.edit = false;
      comment.edit = false;
    }
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
